$(function () {
    if ($('.template-collection').length > 0 || $('#inventory-app').length > 0) {
        // Get the modal
        var modal = document.getElementById("myModal");

        // Get the <span> element that closes the modal
        var span = document.getElementsByClassName("close")[0];

        // When the user clicks on the button, open the modal
        $(".open-warning-modal").on('click', function (e) {
            e.preventDefault();
            modal.style.display = "block";
            $('body').addClass('modal-is-visible');
            $('.warning-modal').addClass('animate-overlay');
            $('.modal-content').addClass('animate-top');
            return false;
        });

        // Cancel button
        $('button.cancel-modal').on('click', function () {
            closeModal(modal);
        });

        // When the user clicks on <span> (x), close the modal
        span.onclick = function () {
            closeModal(modal);
        }

        // When the user clicks anywhere outside of the modal, close it
        window.onclick = function (event) {
            if (event.target == modal) {
                closeModal(modal);
            }
        }
    }
});

function closeModal(modal) {
    modal.style.display = "none";
    $('body').removeClass('modal-is-visible');
}